
export type SupportedLangCode = 'fa' | 'en' | 'ar' | 'pa';

//export type Language = 'farsi' | 'english' | 'arabic' | 'pashto';
export const enum Language {
  Farsi = 'farsi',
  English = 'english',
  Arabic = 'arabic',
  Pashto = 'pashto',
}

export type Outlet = 'iitv' | 'aitv';

export type OutletLanguageMap = {
  iitv: ['fa', 'en', 'ar'];
  aitv: ['fa', 'en', 'pa'];
};

export type OutletLanguages<T extends Outlet> = OutletLanguageMap[T][number];

export type PageParams = {
  lang: SupportedLangCode;
};

export type PageProps = {
  params: Promise<PageParams>;
  searchParams: Promise<{ [key: string]: string | string[] | undefined }>;
};

export const PAGE_IDS: {
  [O in Outlet]: {
    [L in OutletLanguages<O>]: string;
  };
} = {
  iitv: {
    fa: '11159ae8-698a-47d2-b88c-1d947f5290bd',
    ar: '0bd8f387-97e0-41f4-aebd-453dac4e42b5',
    en: 'ce25b5ed-325d-4b77-83d4-0fc31be0be8c',
  },
  aitv: {
    fa: 'ba6776a0-49f8-49c7-bfa9-3243ad42b65e',
    en: '0eff9e88-4e01-4e43-b727-d9b57eb357e6',
    pa: 'd3781096-3619-488c-b9ff-fd328cf2c58c',
  }
};

export function getPageId<T extends Outlet>(
  outlet: T,
  lang: OutletLanguages<T>
): string | undefined {
  return PAGE_IDS[outlet][lang];
}